/* import __COLOCATED_TEMPLATE__ from './tab-button.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface TabButtonArgs {
  activeTab: string;
  enabledTabs: string[];
  type: string;
}

export default class TabButton extends Component<TabButtonArgs> {
  @service declare intl: IntlService;

  get isEnabled(): boolean {
    const index = this.args.enabledTabs.findIndex((item) => {
      return item === this.args.activeTab;
    });
    return !(
      index === -1 ||
      (this.args.type === 'previous' && index === 0) ||
      (this.args.type === 'next' && index === this.args.enabledTabs.length - 1)
    );
  }

  get isPrevious(): boolean {
    return this.args.type === 'previous';
  }

  get isNext(): boolean {
    return this.args.type === 'next';
  }

  get label(): string {
    return this.args.type === 'next'
      ? this.intl.t('navbar.next-tab')
      : this.args.type === 'previous'
        ? this.intl.t('navbar.previous-tab')
        : 'tab';
  }

  get icon(): string {
    return this.args.type === 'next' ? 'Icon_Expand' : 'Icon_Collapse';
  }

  get tab(): string | null {
    const index = this.args.enabledTabs.findIndex((item) => {
      return item === this.args.activeTab;
    });
    if (
      index === -1 ||
      (this.args.type === 'previous' && index === 0) ||
      (this.args.type === 'next' && index === this.args.enabledTabs.length - 1) ||
      !this.args.enabledTabs[index]
    ) {
      return null;
    }
    if (this.args.type === 'previous' && this.args.enabledTabs[index - 1]) {
      return this.args.enabledTabs[index - 1] as string;
    }
    if (this.args.type === 'next' && this.args.enabledTabs[index + 1]) {
      return this.args.enabledTabs[index + 1] as string;
    }
    return this.args.enabledTabs[index] as string;
  }
}
